import { Injectable, inject } from '@angular/core';
import { catchError, of, switchMap, Observable, forkJoin } from 'rxjs';
import { ReportGroupFilterListingService } from 'src/app/services/api/report-group-filter/report-group-filter-listing.service';
import { DevicesDataService } from 'src/app/services/data/devices-data/devices-data.service';
import {
  DEVICE_TYPES,
  STATUSES,
  HEALTH,
  LAST_HEARD,
  BATTERY_STATUS,
  COMMUNICATION_STATUS
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import {
  DeviceTypeGroup,
  FilterModel,
  FilterModels,
  ListingFiltersSource
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { DeviceFirmwareVersionTypeFilter } from '../../components/devices.models';
import { DeviceFilterListingService } from '../../api/devices-api-filters.service';

@Injectable()
export class DcuListingFiltersSourceService implements ListingFiltersSource {
  readonly devices = inject(DevicesDataService);
  readonly devicesFilterListingApiService = inject(DeviceFilterListingService);
  readonly reportGroupFilterService = inject(ReportGroupFilterListingService);

  readonly #applicable = 'AMI Health Dashboard';

  getAll(): Observable<FilterModels> {
    return this.getReportGroup().pipe(
      switchMap(reportGroupFilter =>
        forkJoin([
          of(reportGroupFilter),
          of(DEVICE_TYPES[DeviceTypeGroup.BaseStationAndDCU]),
          of(STATUSES),
          of(HEALTH),
          of(LAST_HEARD),
          of(BATTERY_STATUS),
          of(COMMUNICATION_STATUS),
          this.devicesFilterListingApiService.getDeviceFwVersionsFilter(
            DeviceFirmwareVersionTypeFilter.MotherBoardFirmware
          ),
          this.devicesFilterListingApiService.getDeviceFwVersionsFilter(
            DeviceFirmwareVersionTypeFilter.PowerSupplyFirmware
          ),
          this.devicesFilterListingApiService.getDeviceFwVersionsFilter(
            DeviceFirmwareVersionTypeFilter.J_BoardFirmware
          ),
          this.devicesFilterListingApiService.getDeviceFwVersionsFilter(DeviceFirmwareVersionTypeFilter.T_BoardFirmware)
        ])
      ),
      catchError(err => {
        return of(err);
      })
    );
  }
  getReportGroup(): Observable<FilterModel> {
    return this.reportGroupFilterService.getFilter(this.#applicable);
  }
}
